/**
 * Category → colour registry for the Cash Flow Sankey.
 * Kept in one place so every report and workspace uses the same palette.
 * Mirrors `CATEGORY_COLOURS` in backend/routes/cash_flow_sankey.py.
 */
export const CATEGORY_COLOURS = {
    Income:               "#10b981",
    Salary:               "#0d9488",
    "Business Income":    "#0891b2",
    "Other Income":       "#14b8a6",
    Savings:              "#16a34a",
    Investments:          "#16a34a",
    Housing:              "#d4a24a",
    Mortgage:             "#b3843a",
    "Bills & Utilities":  "#3b82f6",
    Electricity:          "#2563eb",
    Financial:            "#c026d3",
    Loans:                "#a21caf",
    EMI:                  "#a21caf",
    "Food & Dining":      "#fb7185",
    "Travel & Lifestyle": "#8b5cf6",
    Insurance:            "#db2777",
    "Cash / ATM":         "#64748b",
    Miscellaneous:        "#a8a29e",
    "Net Surplus":        "#22c55e",
    "Debt Repayment":     "#ef4444",
    Uncategorised:        "#78716c",
};

export function colourForCategory(name) {
    if (!name) return CATEGORY_COLOURS.Uncategorised;
    const hit = Object.entries(CATEGORY_COLOURS).find(
        ([k]) => k.toLowerCase() === name.toLowerCase()
    );
    if (hit) return hit[1];
    // Deterministic HSL for unknown categories.
    let h = 0;
    for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
    return `hsl(${h % 360}, 65%, 55%)`;
}
